export enum OperationType {
    InviteDriver = 1,
    InviteDispatcher,
    CreateLead,
}
